import React from 'react'

interface TableHeadProps extends Omit<React.HTMLAttributes<HTMLTableSectionElement>, 'className'> {
  children: React.ReactNode;
}

export function TableHead ({ children, ...props }: TableHeadProps) {
  return (
    <thead {...props} className='group/thead'>
      {children}
    </thead>
  )
}

TableHead.displayName = 'Table.Head'
